import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

interface EmptyStateProps {
  children: ReactNode;
  /** Reserve the same height as the content it stands in for (e.g. a chart). */
  height?: number;
}

export function EmptyState({ children, height }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'text-[13px] text-fg-muted',
        height ? 'grid place-items-center rounded-md bg-surface-sunken' : 'px-4 py-6',
      )}
      style={height ? { height } : undefined}
    >
      {children}
    </div>
  );
}
